<p>help-mws-reporting-identity works!</p>
